import { render, staticRenderFns } from "./ProductCaroussel.vue?vue&type=template&id=7e67767a&scoped=true"
import script from "./ProductCaroussel.vue?vue&type=script&lang=js"
export * from "./ProductCaroussel.vue?vue&type=script&lang=js"
import style0 from "./ProductCaroussel.vue?vue&type=style&index=0&id=7e67767a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e67767a",
  null
  
)

export default component.exports